export const StatusImovelEnum = {
  AT: {
    id: 'A',
    nome: 'Ativo',
    color: '#41B739'
  },
  CA: {
    id: 'C',
    nome: 'Cancelado',
    color: '#F56C6C'
  },
  PE: {
    id: 'P',
    nome: 'Pendente',
    color: '#FFBF00'
  },
  SU: {
    id: 'S',
    nome: 'Suspenso',
    color: '#777777'
  },
  IN: {
    id: 'I',
    nome: 'Inscrito',
    color: '#409EFF'
  },
  RE: {
    id: 'R',
    nome: 'Retificado',
    color: '#409EFF'
  },
  AS: {
    id: 'AS',
    nome: 'Aguardando Sincronia',
    color: '#409EFF'
  },
}
